import { CatalogNearMe } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';
import { H4 } from '@liveauctioneers/hammer-ui-core/text';
import { MonochromeLink } from '@liveauctioneers/hammer-ui-core/link';

type Props = {
    catalog: CatalogNearMe;
    catalogsByLocation: Record<string, CatalogNearMe[]>;
};

export const InfoWindowContent = ({ catalog, catalogsByLocation }: Props) => {
    const catalogsAtLocation = catalogsByLocation[`${catalog.lat},${catalog.lon}`];

    return (
        <article className="flex flex-col gap-3xs p-2xs">
            <header>
                <H4>{catalog.houseDetails.name}</H4>
            </header>
            <section className="flex flex-col gap-2xs">
                {catalogsAtLocation.map((catalogItem) => (
                    <div key={catalogItem.id}>
                        <MonochromeLink
                            href={`/catalog/${catalogItem.id}`}
                            size="xs"
                            target="_blank"
                        >
                            {catalogItem.title}
                        </MonochromeLink>
                    </div>
                ))}
            </section>
        </article>
    );
};
